import React  from 'react';
import { HeadLine } from '../../../components/common/Headline';

export const ThreeSections = (props) => {

    let JsonTop10Win = [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5},
        {id: 6},
        {id: 7},
        {id: 8},
        {id: 9},
        {id: 10},
    ] 

    return(
        <div className="threeSection">
             <HeadLine headline="топ-10 победителей" />

             <div className="container">
                <div className="list_winer">
                    {JsonTop10Win.map( (w) => <div key={w.id} className="itemTopWiner">
                                                <h2>{w.id}</h2>
                                                <div className="line_block">
                                                    <svg width="20" height="2" viewBox="0 0 20 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <line y1="1" x2="20" y2="1" stroke="#F6C465" stroke-width="2"/>
                                                    </svg>
                                                </div>
                                                <img src="img/photoMan.png" alt="none"/>
                                                <p>Ivan Fomin</p>
                                            </div>)}
                </div>
                <svg className="big_line" width="1110" height="1" viewBox="0 0 1110 1" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.25" y="0.25" width="1109.5" height="0.5" stroke="#DADADA" stroke-width="0.5"/>
                </svg>
               
                <HeadLine headline="партнеры" />
                <div className="partner_list">
                    <img src="img/listPartners.png" alt=""/>
                </div>
             </div>
        </div>
    )
}